var _style, _defs, _defs2, _path, _defs3, _path2, _defs4, _path3, _defs5, _path4, _defs6, _path5, _defs7, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDepartments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.3 21.5",
    style: {
      enableBackground: "new 0 0 17.3 21.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000000207536761123712160000009589220969489859761_);}\n\t.st3{clip-path:url(#SVGID_00000055706001911383781490000003187259328636247212_);}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#BDB6B8;}\n\t.st6{fill:#1A1A1A;}\n\t.st7{fill:#ADA8AA;}\n\t.st8{fill:#262424;}\n\t.st9{fill:#1E8273;}\n\t.st10{fill:#239281;}\n\t.st11{fill:#262626;}\n\t.st12{fill:#0F0F0F;}\n\t.st13{fill:#212226;}\n\t.st14{opacity:0.25;}\n\t.st15{clip-path:url(#SVGID_00000104701894901438605590000008405573302211216799_);}\n\t.st16{opacity:0.15;}\n\t.st17{clip-path:url(#SVGID_00000163072524174396569690000009042675784551737005_);}\n\t.st18{clip-path:url(#SVGID_00000137851158778098659300000008722879941710809763_);}\n\t.st19{clip-path:url(#SVGID_00000067194993644836592120000005333912193308208061_);}\n\t.st20{clip-path:url(#SVGID_00000080179012730864076110000013214163639863627407_);}\n\t.st21{clip-path:url(#SVGID_00000139987463000256213920000002289390261016417175_);}\n\t.st22{fill:#2B5896;}\n\t.st23{fill:#D71C13;}\n\t.st24{fill:#FF2116;}\n\t.st25{fill:#92130D;}\n\t.st26{fill:#F5F5F5;}\n\t.st27{fill:url(#);}\n\t.st28{fill:#1D7244;}\n\t.st29{fill:#FFFFFF;enable-background:new    ;}\n\t.st30{fill:#207044;enable-background:new    ;}\n\t.st31{fill:#0D6735;}\n\t.st32{fill:#FDFDFD;}\n\t.st33{clip-path:url(#SVGID_00000127044147331489483090000001884013736313891995_);}\n\t.st34{clip-path:url(#SVGID_00000072258307233063298180000012524425571366386332_);}\n\t.st35{clip-path:url(#SVGID_00000134932169886292397950000017078683082485374592_);}\n\t.st36{clip-path:url(#SVGID_00000127014629150469517900000008036270849164905626_);}\n\t.st37{clip-path:url(#SVGID_00000031895775634545852290000014129820368615188913_);}\n\t.st38{clip-path:url(#SVGID_00000117674141035221879960000001994212769282572969_);}\n\t.st39{clip-path:url(#SVGID_00000107581948144238713330000006790400071411587007_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000022549803605742756760000010651260714469812610_",
    width: 17.3,
    height: 21.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086657096404347385720000008432356033957591452_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022549803605742756760000010651260714469812610_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4846",
    style: {
      clipPath: "url(#SVGID_00000086657096404347385720000008432356033957591452_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    transform: "translate(5.284 6.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4829"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000138575710837048331280000003154932918917028507_",
    x: 0,
    y: 0,
    width: 6.8,
    height: 15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078744134655295018420000014088930845522345383_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138575710837048331280000003154932918917028507_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    style: {
      clipPath: "url(#SVGID_00000078744134655295018420000014088930845522345383_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    className: "st0",
    d: "M6.8,1.8v5c0,0.1,0,0.2-0.1,0.2C6.4,7.3,6,7.5,5.6,7.6c-0.1,0-0.2,0.2-0.2,0.3v6.5 c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.2-0.4,0.3c0,0-0.1,0-0.1,0H2.2c0,0-0.1,0-0.1,0c-0.2-0.1-0.3-0.2-0.5-0.3 c-0.1-0.1-0.1-0.1-0.1-0.2V7.9c0-0.1-0.1-0.3-0.2-0.3c-0.6-0.1-1-0.5-1.2-1c0,0,0-0.1,0-0.1V1.7c0,0,0-0.1,0-0.1 C0.3,1,0.8,0.5,1.4,0.2c0,0,0,0,0.1,0C1.8,0.1,2.1,0,2.4,0h0c0.1,0,0.2,0,0.2,0.1L3,0.4l0,0l0.2,0.2c0.1,0.1,0.3,0.1,0.4,0 c0,0,0,0,0,0l0.1-0.1l0.1-0.1l0.3-0.3C4.2,0,4.3,0,4.4,0h0.1C4.7,0,5,0.1,5.3,0.2h0C6,0.5,6.6,1,6.8,1.8 C6.8,1.8,6.8,1.8,6.8,1.8"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    transform: "translate(11.23 5.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4832"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000088824394614677219890000017714194568483137423_",
    x: 0,
    y: 0,
    width: 6.1,
    height: 15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021812182632819391780000009221087830814941073_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088824394614677219890000017714194568483137423_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4831",
    style: {
      clipPath: "url(#SVGID_00000021812182632819391780000009221087830814941073_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    className: "st0",
    d: "M6.1,1.6v5.2c0,0,0,0.1,0,0.1C6,7,6,7,6,7.1C5.7,7.4,5.4,7.6,5,7.7C4.8,7.7,4.7,7.8,4.7,8 v6.5c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.2-0.5,0.3c0,0-0.1,0-0.1,0H1.6l-0.1,0c-0.2-0.1-0.4-0.2-0.5-0.4 c-0.1-0.1-0.1-0.1-0.1-0.2v-5c0-0.1,0-0.2,0.1-0.2C1.2,9,1.4,8.8,1.5,8.6c0,0,0-0.1,0-0.1V3.2c0,0,0-0.1,0-0.1 C1.4,2.6,1.2,2.2,0.9,1.8C0.7,1.5,0.4,1.3,0.1,1.1C0,1,0,0.8,0,0.7c0,0,0-0.1,0.1-0.1c0.2-0.2,0.5-0.3,0.8-0.4 C1.1,0.1,1.3,0,1.5,0c0.1,0,0.2,0,0.3,0C1.9,0,2,0,2,0l0,0l0.3,0.4l0.2,0.3c0.1,0.1,0.3,0.1,0.4,0c0,0,0,0,0,0l0.2-0.2 l0.3-0.4C3.6,0,3.7,0,3.8,0l0,0c0.3,0,0.6,0.1,0.9,0.2c0.6,0.2,1,0.7,1.3,1.2C6.1,1.5,6.1,1.5,6.1,1.6"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    transform: "translate(0 5.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4835"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065760552188364816480000017722501428041638287_",
    y: 0,
    width: 6.3,
    height: 15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136387241045397431580000010884179651818123439_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065760552188364816480000017722501428041638287_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4834",
    style: {
      clipPath: "url(#SVGID_00000136387241045397431580000010884179651818123439_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    className: "st0",
    d: "M4.8,2.9v5.5c0,0,0,0.1,0,0.1C4.9,8.8,5,8.9,5.2,9.1c0.1,0.1,0.1,0.1,0.1,0.2v5.1 c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.2-0.4,0.3c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0H2.2c0,0-0.1,0-0.1,0 c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.1-0.1-0.1-0.1-0.2V7.9c0-0.1-0.1-0.3-0.2-0.3C0.7,7.5,0.3,7.2,0.1,6.7C0,6.6,0,6.4,0,6.3 C0,6.1,0,6,0.1,5.9c0,0,0-0.1,0-0.1V1.7c0,0,0-0.1,0-0.1C0.3,1,0.8,0.5,1.4,0.3C1.7,0.1,2,0.1,2.3,0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.2,0,0.2,0.1L3,0.5l0.1,0.2c0.1,0.1,0.3,0.1,0.4,0c0,0,0,0,0,0l0.1-0.2l0.3-0.4C4.1,0.1,4.2,0,4.3,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0.1,0.5,0.1c0.3,0.1,0.6,0.3,0.9,0.6c0.1,0.1,0.1,0.3,0,0.4 c0,0-0.1,0-0.1,0.1C5.8,1.4,5.5,1.6,5.3,1.8C5,2.1,4.8,2.5,4.8,2.9"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4839",
    transform: "translate(1.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4838"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000110440188373844109710000006933436657684297612_",
    x: 0,
    width: 4.3,
    height: 4.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164491474474618659860000011251534019141945535_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110440188373844109710000006933436657684297612_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4837",
    style: {
      clipPath: "url(#SVGID_00000164491474474618659860000011251534019141945535_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    className: "st0",
    d: "M4.3,2.2c0,1.2-1,2.2-2.2,2.2C1,4.3,0,3.4,0,2.2C0,1,1,0,2.2,0C3.4,0,4.3,1,4.3,2.2 C4.3,2.2,4.3,2.2,4.3,2.2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    transform: "translate(6.553 1.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4841"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016076293682942153140000002944973772970933934_",
    x: 0,
    y: 0,
    width: 4.3,
    height: 4.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067216945055836943660000011159011472706487682_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016076293682942153140000002944973772970933934_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    style: {
      clipPath: "url(#SVGID_00000067216945055836943660000011159011472706487682_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    className: "st0",
    d: "M4.3,2.2c0,1.2-1,2.2-2.2,2.2C1,4.3,0,3.4,0,2.2S1,0,2.2,0S4.3,1,4.3,2.2L4.3,2.2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    transform: "translate(11.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4844"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000027563982728664884330000000709142228975220891_",
    x: 0,
    width: 4.3,
    height: 4.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057832503769539127880000015956065034194133903_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027563982728664884330000000709142228975220891_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4843",
    style: {
      clipPath: "url(#SVGID_00000057832503769539127880000015956065034194133903_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    className: "st0",
    d: "M4.3,2.2c0,1.2-1,2.2-2.2,2.2C1,4.3,0,3.4,0,2.2S1,0,2.2,0c0,0,0,0,0,0 C3.4,0,4.3,1,4.3,2.2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDepartments);
export default __webpack_public_path__ + "static/media/icon_departments.b9ceb7099e2a5a09c9d8a6d695870425.svg";
export { ForwardRef as ReactComponent };